import { Controller } from "@hotwired/stimulus"

// Submits the form as soon as a control in it changes — for settings where a
// separate "save" button is only in the way.
export default class extends Controller {
    submit() {
        this.element.requestSubmit()
    }
}
